import React from 'react';
import './KioskoInicio.css'; // Asegúrate de importar el archivo CSS

const KioskoInicio = () => {
  return (
    <div style={styles.container}>
<div className="starry-bg" style={styles.starryBg} />
      <div className="floating-box" style={styles.contentWrapper}>
        <h2 style={styles.title} className="mintaka-title">MINTAKA</h2>
        <p style={styles.subtitle} className="mintaka-subtitle">By Grupo Orión</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    height: 'calc(100vh - 60px)',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom right, #01025e, #0039a6)',
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 2,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#ffffff',
  },
  title: {
    fontSize: '4rem',
    fontWeight: '900',
    marginBottom: '0.5rem',
    letterSpacing: '2px',
  },
  subtitle: {
    fontSize: '1.5rem',
    fontWeight: '300',
    color: '#fdd835',
    letterSpacing: '1px',
  },
  starryBg: {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
  },
};


export default KioskoInicio;
